import React, { Fragment } from "react";
import { connect } from "react-redux";
import { any, func } from "prop-types";
import moment from "moment";
import history from "../../history";
import FormCreatorV2 from "../../common/FormCreatorV2";
import { postWoodlandForms } from "../../redux/actions/woodlandActions";
import {
  formCreatorConvertToValues,
  useForm,
} from "../../common/FormCreator/helpers";
import HorizontalLine from "../../common/HorizontalLine";

const PoliciesAndProcedures = ({ appData, postWoodlandFormsFunc }) => {
  const initialState = {
    blurb1: {
      htmlObj: (
        <Fragment>
          <HorizontalLine text={"Section 2 – Policies and Procedures"} />
          <div>I have read and understand the following:</div>
        </Fragment>
      ),
    },
    pp1: {
      type: "singlecheckbox",
      title: "Health and Safety Policy",
      mandatory: true,
    },
    pp2: {
      type: "singlecheckbox",
      title: "Emergency Procedures",
      mandatory: true,
    },
    pp3: {
      type: "singlecheckbox",
      title: "Safe Working Procedures",
      mandatory: true,
    },
    pp4: {
      type: "singlecheckbox",
      title: "Risk Assessment",
      mandatory: true,
    },
    pp5: {
      type: "singlecheckbox",
      title:
        "Alcohol and Drugs Testing. I understand that I have the right to decline my consent and could result in a Company disciplinary, if suspected.",
      mandatory: true,
    },
    pp6: {
      type: "singlecheckbox",
      title: "Food hygiene policy",
      mandatory: true,
    },
    pp7: {
      type: "singlecheckbox",
      title: "CCTV policy",
      mandatory: true,
    },
  };
  const [fields, setField] = useForm(initialState);
  const woodland = appData.woodlandGroupOnboarding;
  const submitted = woodland && woodland.policies;

  const redirectBack = () => {
    history.push("/profile/edit/woodland-group-onboarding");
  };

  const handleSubmit = () => {
    const fieldValuesPayload = formCreatorConvertToValues(fields);
    postWoodlandFormsFunc("policies", {
      ...fieldValuesPayload,
      date: moment().toISOString(),
    });
    redirectBack();
  };

  return (
    <>
      {submitted ? (
        redirectBack()
      ) : (
        <FormCreatorV2
          formTitle={"Policies and Procedures"}
          helper={""}
          fields={fields}
          setField={setField}
          handleCancel={() => redirectBack()}
          onboardingBranch={"woodlandBranch"}
          useSubmitText={true}
          handleSubmit={handleSubmit}
        />
      )}
    </>
  );
};

PoliciesAndProcedures.propTypes = {
  appData: any,
  postWoodlandFormsFunc: func,
};

const mapDispatchToProps = {
  postWoodlandFormsFunc: postWoodlandForms,
};

const mapStateToProps = (state) => ({
  appData: state.core.app,
});

const withRedux = connect(mapStateToProps, mapDispatchToProps);
export default withRedux(PoliciesAndProcedures);
